/* =========================================================================================================
   NJ: menus and dropdowns open and close instantly (no fade, no slide, no staggered items)

   Prestige animates these with JavaScript (the Motion library, which uses the browser's Web Animations API), not
   with CSS, so this hooks Element.animate and sets the duration to 0 for everything inside:
   - the header: desktop dropdown menus and mega menus, the search
   - the mobile menu (header-sidebar) and its sub panels
   - popovers (Sort by, View, the country/language selector)
   Everything else (cart drawer, product drawers, image reveals) keeps its animation.
   ========================================================================================================= */
(() => {
  "use strict";

  const SELECTOR = "x-header, header-sidebar, x-popover, dropdown-menu-disclosure, mega-menu-disclosure, header-search";

  const isInstant = (element) => {
    let node = element;
    // Parts inside a shadow root (popover overlay/content) belong to their host element
    const root = node.getRootNode && node.getRootNode();
    if (root && root.host) node = root.host;
    return !!(node.closest && node.closest(SELECTOR));
  };

  const original = Element.prototype.animate;
  if (typeof original !== "function" || original.__njInstant) return;

  const patched = function (keyframes, options) {
    try {
      if (isInstant(this)) {
        if (typeof options === "number") options = 0;
        else options = Object.assign({}, options || {}, { duration: 0, delay: 0, endDelay: 0 });
      }
    } catch (e) {}
    return original.call(this, keyframes, options);
  };
  patched.__njInstant = true;
  Element.prototype.animate = patched;
})();
